import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const ChevronRight = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="chevron-right">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 12C16 12.2652 15.8946 12.5196 15.7071 12.7071L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071C8.90237 17.3166 8.90237 16.6834 9.29289 16.2929L13.5858 12L9.29289 7.70711C8.90237 7.31658 8.90237 6.68342 9.29289 6.29289C9.68342 5.90237 10.3166 5.90237 10.7071 6.29289L15.7071 11.2929C15.8946 11.4804 16 11.7348 16 12Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
